import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import LabeledEntry from "../../helpers/LabeledEntry";

const EditableField = ({
  label,
  type,
  id,
  name,
  initialValue,
  placeholder,
  required,
  isEditable,
  onChange,
  multiline = false,
  rows = 1,
  variant = "standard",
}) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    if (!isEditable) {
      setValue(initialValue);
    }
  }, [isEditable, initialValue]);

  const handleChange = (event) => {
    setValue(event.target.value);
    if (onChange) {
      onChange(name, event.target.value);
    }
  };

  return (
    <>
      {isEditable ? (
        <TextField
          variant={variant}
          label={label}
          type={type}
          id={id}
          name={name}
          required={required}
          value={value}
          fullWidth
          onChange={handleChange}
          multiline={multiline}
          rows={rows}
        />
      ) : (
        <LabeledEntry
          label={label}
          value={initialValue}
          placeholder={placeholder}
        />
      )}
    </>
  );
};

export default EditableField;